import { BASE_URL_API } from "../../configs";

const BrandFooter = () => {

    const apiUrl = BASE_URL_API ?? ''

    const dafcLogo = apiUrl + '/images/brands/logo-ippgroup.png'

    const items = [];

    return (
        <>
            <div className="px-4 py-4 font-main">
                <div className="justify-center mx-auto my-5 w-[170px] h-auto">
                    <img className="flex justify-center mx-auto my-5 w-[170px] h-auto" src={dafcLogo} alt="DAFC" width={170} height={26} />
                </div>
                <p className="font-normal text-[14px] leading-[1.6] text-justify">
                    Established in 1985, <span className="font-bold">IPPG</span> is Vietnam’s leading luxury
                    retail and non-aviation services group. We are pioneers in international terminal investment and
                    operation, with a strong portfolio of over 138 prestigious global brands.
                    <br/>
                    With 17 subsidiaries, 18 joint ventures, and over 20,000 employees, IPPG continues to shape Vietnam’s premium retail landscape and infrastructure development.
                    <br/>
                    Mission: Bring the best of the world to Vietnam.
                </p>
                <div className="grid grid-cols-3 grid-rows-3 gap-4 pt-6 pb-5">
                </div>
            </div>
        </>
    )
}

export default BrandFooter;